<h2 class="mbottom-12">
  Enter your student information
  <yat-tooltip-info-icon id="24908df0-7ddd-45dd-973a-04fba81133b0"
    iconClass="ml-1"
    tooltipClass="tooltip-xl"
    tooltipContent="We need your student information to verify your student status. Your data will be kept safe and sound.">
  </yat-tooltip-info-icon>
</h2>
<form [formGroup]="studentDetailsForm" (yatSubmit)="submitForm($event)">
  <div class="form-row mt-1">
    <div class="form-group col-12 mbottom-12">
      <label for="student-number">Student number</label>
      <input class="form-control" id="student-number" formControlName="studentNumber" maxlength="32" yatAutoFocus yatInput />
      <div class="invalid-feedback" [ngSwitch]="studentDetailsForm.controls.studentNumber.errors | classifyValidationError">
        <span *ngSwitchCase="'required'">Even Alan Turing had to look up his student number.</span>
      </div>
    </div>
  </div>
  <div class="form-row pb-1">
    <div class="col-12">
      <div class="form-group mb-0">
        <label>Student ID</label>
      </div>
      <yat-file-select [maxFileSize]="5" [fileTypes]="['jpg', 'png', 'pdf']" formControlName="studentId"></yat-file-select>
    </div>
  </div>
  <div class="mbottom-12 pt-2">
    <yat-buttons id="0103b923-3a41-456c-8f7f-d3f224628a02"
      primaryButtonName="Complete registration"
      secondaryButtonName="Back"
      (secondaryButtonClickMethod)="goBack()"
      [useYatAutoSpinner]="startAcademicVerificationActionFilter">
    </yat-buttons>
  </div>
  <div class="row">
    <div class="col-12">
      <yat-terms-note id="c53b9fb6-744c-4ae4-90e0-f6e4a0974aa4"></yat-terms-note>
    </div>
  </div>
</form>
